import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id CD9C04DB-710E-4FD1-A679-535C5EF50BFB
 * name view-compact
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/view-compact.svg
 * tags
 * - View 
 */
export const ViewCompactIcon = createSvgIcon(<><path d="M3,19H9V12H3V19M10,19H22V12H10V19M3,5V11H22V5H3Z" /></>, 'ViewCompactIcon');
export default ViewCompactIcon